import { render, staticRenderFns } from "./ChartjsDoughnut.vue?vue&type=template&id=4e4e8427"
import script from "./ChartjsDoughnut.vue?vue&type=script&lang=js"
export * from "./ChartjsDoughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports